import React from 'react';
import { Message } from 'rsuite';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, keys, startCase, toUpper } from 'lodash/fp';

const ErrorHeading = styled.div`
  font-size: 16px;
  margin-bottom: 5px;
`;

const FieldLabel = styled.span`
  width: 128px;
  text-align: right;
  font-size: 12px;
  font-weight: bold;
  margin-right: 10px;
  margin-bottom: 3px;
  display: inline-block;
`;

const fieldToLabel = field => {
  switch (field) {
    case 'programs':
      return 'HELP DESIRED';
    case 'requestTime':
      return 'AVAILABLE TIME';
    case 'householdTotal':
      return 'TOTAL INDIVIDUALS';
    case 'state':
      return 'STATE/PROVINCE';
    case 'zipCode':
      return 'ZIP/POSTAL CODE';
    default:
      return toUpper(startCase(field));
  }
};

const composeFormErrors = formError =>
  keys(formError).map(field => (
    <div key={field}>
      <FieldLabel>{fieldToLabel(field)} : </FieldLabel>
      {get(field, formError)}
    </div>
  ));

const FormErrorMessage = ({ formError }) => (
  <Message
    showIcon
    type="error"
    title={<ErrorHeading>Please correct form error: </ErrorHeading>}
    description={composeFormErrors(formError)}
    style={{ marginBottom: 20 }}
  />
);

FormErrorMessage.propTypes = {
  formError: PropTypes.shape({}).isRequired
};

export default FormErrorMessage;
